/* eslint-disable prefer-template */
import merge from 'lodash/merge';
import { put, call } from 'redux-saga/effects';

import Router from 'next/router';
import AuthStorage from 'src/utils/AuthStorage';

import API from '../constants/url';
import ENV from '../constants/env';

import { REQUEST_ERROR } from '../redux/actions/type';

const { API_URL } = API;

export const fetching = (url, options, originalParams) => {

	// Create a a-link into the dom
	const anchor = document.createElement("a");
	document.body.appendChild(anchor);

	// const path = require('path');
	const path = require('path')
	const fileName = path.basename(originalParams.fileName)

	return fetch(API_URL + url + '?c=' + Math.random().toString(), options)
		.then(response => {
			return response.status === 200 ? response.blob() : response;
		})
		.then(response => {
			if (response.type === 'application/pdf') {
				let objectUrl = window.URL.createObjectURL(response);

				// assign property to the previously created a-link and emulate click
				anchor.href = objectUrl;
				anchor.target = "_blank";
				anchor.download = fileName;
				anchor.click();

				// For Firefox it is necessary to delay revoking the ObjectURL
				setTimeout(() => {
					window.URL.revokeObjectURL(objectUrl);
					document.body.removeChild(anchor);
				}, 100);
			}
		})
		.finally(json => {
			if (json.error) {
				throw json.error;
			} else {
				return json;
			}
		})
}

export default function* ({ uri, params = {}, opt = {}, loading = true, uploadFile = false }) {
	const defaultOptions = {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json',
			'Accept-Language': 'fr'
		}
	};

	if (!uri) {
		return;
	}

	const options = merge(defaultOptions, opt);

	if (uploadFile && params.files) {
		options.headers = {};
	}

	// set token
	if (AuthStorage.loggedIn) {
		options.headers.Authorization = `Bearer ${AuthStorage.token}`;
	}

	let url = uri;

	if (params && Object.keys(params).length > 0) {
		if (options && options.method === 'GET') {
			url +=
				'?' +
				Object.keys(params)
					.map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
					.join('&');
		} else if (uploadFile && params.files) {
			const formData = new FormData();
			if (Array.isArray(params.files)) {
				params.files.forEach(file => {
					formData.append(file.field, file.file);
				});
			}

			options.body = formData;
		} else {
			options.body = JSON.stringify(params);
		}
	}

	if (loading) {
		yield put({ type: 'TOGGLE_LOADING' });
	}

	let response;
	try {
		if (ENV !== 'production') {
			// console.info('====> Call' + url, ', options=', options);
		}

		response = yield call(fetching, url, options, params);

		if (loading) {
			yield put({ type: 'TOGGLE_LOADING' });
		}
	} catch (error) {
		response = { error };

		if (error.message !== 'Unexpected end of JSON input') {
			if (error.statusCode === 401 && error.code !== 'ACCOUNT_DISABLED') {
				// Access token has expired
				if (error.code === 'INVALID_TOKEN') {

					yield put({ type: REQUEST_ERROR, payload: 'Access token has expired' });
					Router.push('/login');
				}
				if (error.code === 'AUTHORIZATION_REQUIRED') {
					yield put({
						type: REQUEST_ERROR,
						payload: "You don't have permission for this action!"
					});
				}
			} else if (error.statusCode === 401 && error.code === 'ACCOUNT_DISABLED') {
				// Access token has expired
				// if (AuthStorage.loggedIn) {
				//  yield put({ type: 'LOGOUT_SUCCESS' });
				// }

				yield put({ type: REQUEST_ERROR, payload: 'Account has been disabled' });
				Router.push('/login');
			} else {
				yield put({ type: REQUEST_ERROR, payload: error.message || error });
			}
		}
	}

	return response;
}
